import React from 'react';
import {IPackageProto, MutateClassPackRequest, PackageProto} from "../../../../../provider_api";
import {useProviderProfile} from "../../../../../ProviderProfileProvider";
import {useParams} from "react-router-dom";
import {EditableStringField} from "../../../../../components/Editable/EditableStringField";
import {findClassPack} from "../../Calendar/CalendarUtil";
import {EditableMultiSelect} from "../../../../../components/Editable/EditableMultiSelect";
import {priceToString} from "../../../../../util/PriceUtil";
import {KensuProfileEditor} from "../../../../../components/table/KensuProfileEditor";
import {EditablePriceField} from "../../../../../components/Editable/EditablePriceField";

export const AddOrUpdateClassPack = () => {

  const {idParam} = useParams();
  const {businessProfile} = useProviderProfile();

  const allPrepaidClassesAndServices = [
    ...(businessProfile?.studio?.classTemplates?.filter(template => !!template.paymentPolicy?.prepaid).map(template => {
      return {
        label: `${template.name} (${priceToString(template.paymentPolicy?.prepaid?.price, true)})`,
        value: template.classTemplateId as string,
      }
    }) ?? []),
  ...(businessProfile?.practice?.services?.filter(service => !!service.paymentPolicy?.prepaid).map(service => {
      return {
        label: `${service.name} (${priceToString(service.paymentPolicy?.prepaid?.price, true)})`,
        value: service.sku as string,
      }
    }) ?? []),
  ]

  return <KensuProfileEditor<IPackageProto>
      idParam={idParam}
      entityName={'Package'}
      entityListViewLink={'../packages'}
      archiveField={"archived"}
      getFromProfile={findClassPack}
      getTitle={classPack => classPack.displayName}
      newBlankType={() => new PackageProto({price: {currencyCode: 'USD'}})}
      getRpcMethod={isUpdate => isUpdate ? 'update_class_pack' : 'create_class_pack'}
      getRpcPayload={classPack => MutateClassPackRequest.encode(
          new MutateClassPackRequest({
            classPack: classPack
          })).finish()}>

    <EditableStringField<IPackageProto>
        inputType={'text'}
        label={'Name'}
        field={'displayName'}
    />

    <EditableMultiSelect<IPackageProto, string>
        label={'Included classes or services'}
        immutable={true}
        field={'includedClassOrServiceIds'}
        options={allPrepaidClassesAndServices}
    />

    <EditableStringField<IPackageProto>
        label={'Number of classes included (use 0 for unlimited)'}
        // These are here to parse a number from the string.
        getter={entity => entity.classLimit?.toString()}
        setter={(entity, value) => ({...entity, classLimit: parseInt(value)})}
        field={'classLimit'}
        inputType={'number'}/>

    <EditablePriceField<IPackageProto>
        label={'Price (USD)'}
        field={'price'}
    />

    <EditableStringField<IPackageProto>
        label={'Expiration (days)'}
        helpText={'e.g. 31 for one month, 365 for one year. 0 means no expiration.'}
        getter={entity => entity.expirationDays?.toString()}
        setter={(entity, value) => ({...entity, expirationDays: parseInt(value)})}
        field={'expirationDays'}
        inputType={'number'}/>

  </KensuProfileEditor>;
};

